module.exports = __webpack_public_path__ + "static/media/spisestuenfinal.510ea421.png";